import React, { PropsWithChildren, useEffect } from 'react';
import { PlanType } from 'src/types/user.model';
import { useEligibility } from 'src/hooks/queries/eligibility';
import { EligibilityStatus } from 'src/types/eligibility.model';
import Loading from 'src/components/atomic/atoms/loading/Loading';
import { Redirect } from 'react-router-dom';
import { SignupPayload } from 'src/services/auth.service';
import { useLoginUser, useSignupUser } from 'src/hooks/queries/users';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import { goToLandingPage } from 'src/services/router.service';

export const spendsmartTermsAcceptedCookie = 'spendSmartTermsAccepted';

export default function BudgetingAuthWrapper({ children }: PropsWithChildren<unknown>): JSX.Element {
    const { isLoading: isLoadingEligibility, data: eligibility } = useEligibility(PlanType.BUDGETING);
    const isSignedUp: boolean =
        eligibility?.userStatus === EligibilityStatus.ACTIVE ||
        eligibility?.userStatus === EligibilityStatus.ONBOARDING;
    useLoginUser(isSignedUp);
    const { mutateAsync: signupUser } = useSignupUser();

    useEffect(() => {
        if (eligibility?.userStatus === EligibilityStatus.ELIGIBLE) {
            if (!document.cookie.includes(spendsmartTermsAcceptedCookie)) {
                goToLandingPage();
                return;
            }
            const signupPayload: SignupPayload = {
                planType: PlanType.BUDGETING,
                userOrigin: 'SpendSmart landing page',
                termsVersion: 1
            };
            void signupUser(signupPayload);
        }
    }, [isLoadingEligibility]);

    if (isSignedUp) return <>{children}</>;

    if (eligibility?.userStatus === EligibilityStatus.INELIGIBLE) return <Redirect to={BudgetPages.INELIGIBLE} />;

    return <Loading />;
}
